/* eslint-disable no-alert, no-console */
import { loadApp } from './app/config/setup-app';

void loadApp();
